class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.AnnouncementBarElements = this.querySelectorAll('.announcement-bar');

    let i = 0;

    setInterval(() => {
      this.AnnouncementBarElements[i].classList.remove(
        'announcement-bar--visible'
      );
      i = i == this.AnnouncementBarElements.length - 1 ? 0 : i + 1;
      this.AnnouncementBarElements[i].classList.add(
        'announcement-bar--visible'
      );
    }, 5000);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
